type acceptedPhoneNumber = string | null | undefined;

/**
 * react-text-mask `pipe`: runs on every keystroke against the raw
 * (unmasked) input, not the mask's own conformed output. A leading "1"
 * country code (from a paste or autofill like "+1 314-686-2109") desyncs
 * the mask's digit-by-position mapping and silently corrupts the number
 * (e.g. produces "(131) 468-6210" instead of "(314) 686-2109"). Strip it
 * before formatting so the mask only ever sees the 10 national digits.
 */
export function phoneMaskPipe(
  conformedValue: string,
  config: { rawValue: string }
): string {
  const rawDigits = config.rawValue.replace(/\D/g, '');
  const digits =
    rawDigits.length === 11 && rawDigits.startsWith('1')
      ? rawDigits.slice(1)
      : rawDigits;

  if (digits.length !== 10) {
    return conformedValue;
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export const formatPhoneNumber = (phone: acceptedPhoneNumber) => {
  if (!phone) {
    return '';
  }

  let cleanedPhone = phone.replace(/\D/g, '') || '';
  let processedPhone = '';

  const matched = cleanedPhone.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (matched) {
    processedPhone += `(${matched[1]}) ${matched[2]}-${matched[3]}`;
  }

  return processedPhone;
};
